import { createContext, useContext, useEffect, useMemo } from 'react';
import { isAdminPath, pathForSection, sectionFromPath, useLocation } from '../router/location';

const AdminViewContext = createContext(null);

export function AdminViewProvider({ enabled, children }) {
  const { pathname, navigate } = useLocation();
  const section = sectionFromPath(pathname);
  const isAdmin = Boolean(enabled);

  useEffect(() => {
    if (!isAdmin && isAdminPath(pathname)) {
      navigate('/', { replace: true });
      return;
    }
    if (isAdmin && section === 'unknown') {
      navigate('/admin', { replace: true });
    }
  }, [isAdmin, pathname, section, navigate]);

  const value = useMemo(
    () => ({
      enabled: isAdmin,
      open: isAdmin && section != null && section !== 'unknown',
      section: section === 'unknown' ? 'overview' : section,
      openAdmin: () => navigate('/admin'),
      closeAdmin: () => navigate('/'),
      goSection: (id) => navigate(pathForSection(id)),
    }),
    [isAdmin, section, navigate]
  );

  return <AdminViewContext.Provider value={value}>{children}</AdminViewContext.Provider>;
}

export function useAdminView() {
  return useContext(AdminViewContext);
}
